import type { SVGProps } from 'react';

export const ChevIcon = (p: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 12 12" className="chev" fill="none" stroke="currentColor" strokeWidth="1.75" {...p}>
        <path d="m3 5 3 3 3-3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const BookmarkIcon = (p: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.75" {...p}>
        <path d="M4 2h8v12l-4-3-4 3z" strokeLinejoin="round" />
    </svg>
);

export const ArrRightIcon = (p: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.75" width="14" height="14" {...p}>
        <path d="m6 4 4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const InfoIcon = (p: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.75" {...p}>
        <circle cx="8" cy="8" r="6.5" />
        <path d="M8 7v4M8 5v.01" strokeLinecap="round" />
    </svg>
);
